import './circularLoader.scss';

import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import {
  DEFAULT_LOADER_SIZE,
  LOADER_BORDER_RATIO,
} from './constants/loaderSize';
import { CircularLoaderProps } from './types/CircularLoaderProps';

export const CircularLoader = ({
  color = 'currentColor',
  fullscreen = false,
  size = DEFAULT_LOADER_SIZE,
  testId = locator.components.circularLoader.root,
}: CircularLoaderProps): ReactNode => (
  <div
    className={`circular-loader ${
      fullscreen ? 'circular-loader-fullscreen' : ''
    }`.trim()}
    data-testid={testId}
    role="presentation"
  >
    <div
      className="circular-loader-spinner"
      style={{
        borderBottomColor: color,
        borderRightColor: color,
        borderTopColor: color,
        borderWidth: size * LOADER_BORDER_RATIO,
        height: size,
        width: size,
      }}
    />
  </div>
);
